export const DELETE_QUOTE_REQUEST = 'DELETE_QUOTE_REQUEST';
export const DELETE_QUOTE_SUCCESS = 'DELETE_QUOTE_SUCCESS';
export const DELETE_QUOTE_ERROR = 'DELETE_QUOTE_ERROR';
